const signEdit = [{
  path: 'signEdit/index',
  component: resolve => require(['../../../../components/pages/user/signEdit'], resolve)
}]

export default signEdit



// WEBPACK FOOTER //
// ./src/router/pages/user/signEdit/index.js